import { render, staticRenderFns } from "./DatasetEdit.vue?vue&type=template&id=f4903f66&scoped=true&"
import script from "./DatasetEdit.vue?vue&type=script&lang=js&"
export * from "./DatasetEdit.vue?vue&type=script&lang=js&"
import style0 from "./DatasetEdit.vue?vue&type=style&index=0&id=f4903f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4903f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4903f66')) {
      api.createRecord('f4903f66', component.options)
    } else {
      api.reload('f4903f66', component.options)
    }
    module.hot.accept("./DatasetEdit.vue?vue&type=template&id=f4903f66&scoped=true&", function () {
      api.rerender('f4903f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/DatasetEdit.vue"
export default component.exports